import { BOOKS_COUNTERS_SET_DATA } from 'rebook/apps/books/constants';


const initialState = {
  audio: 15000,
  standard_free: 136000,
  free: 31000,
  standard: 105000,
  only_pro: 17000,
  total: 153000,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BOOKS_COUNTERS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
